import React from 'react';
export function Footer() {
  return <footer className="bg-brand-bg text-brand-muted px-4 py-8 border-t border-brand-border" data-id="element-58">
      <div className="max-w-xl mx-auto text-center" data-id="element-59">
        <p className="text-xs" data-id="element-60">
          © 2026 Mega Pack Maestro Electricista — Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}